import type { UIIconColor, UIIconColorPalette } from './ui-icon.types';
import type { AttributeValidationHandler } from '../ui-element.type';

export enum UIIconSizes {
    Small = 'small',
    Medium = 'medium',
    Avatar = 'avatar',
    Large = 'large',
    ExtraLarge = 'extra-large',
}

export enum UIIconSymbolicShapes {
    Circle = 'circle',
    Square = 'square',
}

export enum UIIconGlyphs {
    Add = 'add',
    Agree = 'agree',
    AlertError = 'alert-error',
    AlertInfo = 'alert-info',
    AlertSuccess = 'alert-success',
    AlertWarning = 'alert-warning',
    AreaCode = 'area-code',
    AtmIn = 'atm-in',
    AtmInOut = 'atm-in-out',
    Bell = 'bell',
    Calculator = 'calculator',
    Calendar = 'calendar',
    Cart = 'cart',
    Chart = 'chart',
    Chat = 'chat',
    Children = 'children',
    Code = 'code',
    Copy = 'copy',
    Cross = 'cross',
    Delete = 'delete',
    Dialog = 'dialog',
    DialogCircle = 'dialog-circle',
    Document = 'document',
    Down = 'down',
    Download = 'download',
    Dropdown = 'dropdown',
    DropdownArrowDown = 'dropdown-arrow-down',
    DropdownArrowUp = 'dropdown-arrow-up',
    Edit = 'edit',
    Education = 'education',
    Envelope = 'envelope',
    Exchange = 'exchange',
    Exclamation = 'exclamation',
    Excluded = 'excluded',
    Expences = 'expences',
    FaceLaugh = 'face-laugh',
    FaceSmile = 'face-smile',
    Facebook = 'facebook',
    Favorites = 'favorites',
    Food = 'food',
    Gear = 'gear',
    Heart = 'heart',
    Income = 'income',
    Information = 'information',
    Instagram = 'instagram',
    Insurance = 'insurance',
    Left = 'left',
    Linkedin = 'linkedin',
    Loader = 'loader',
    Location = 'location',
    Lock = 'lock',
    LogIn = 'log-in',
    LogOut = 'log-out',
    Maximize = 'maximize',
    Minus = 'minus',
    NewWindow = 'new-window',
    Options = 'options',
    Paw = 'paw',
    PercentS = 'percent-s',
    Pfm = 'pfm',
    Phone = 'phone',
    Play = 'play',
    Print = 'print',
    Profile = 'profile',
    Question = 'question',
    Right = 'right',
    Savings = 'savings',
    Schedule = 'schedule',
    Screenshare = 'screenshare',
    ScreenshareOff = 'screenshare-off',
    Search = 'search',
    SearchForm = 'search-form',
    SendArrow = 'send-arrow',
    Skype = 'skype',
    SmartId = 'smart-id',
    StarFull = 'star-full',
    StarHollow = 'star-hollow',
    Sun = 'sun',
    Time = 'time',
    TimeHand = 'time-hand',
    Transport = 'transport',
    Twitter = 'twitter',
    Unknown = 'unknown',
    Up = 'up',
    Upload = 'upload',
    Video = 'video',
    VideoCall = 'video-call',
    VideoChat = 'video-chat',
    VideoChatOff = 'video-chat-off',
    VideoOff = 'video-off',
    VideoSound = 'video-sound',
    VideoSoundOff = 'video-sound-off',
    View = 'view',
    Wheelchair = 'wheelchair',
    Youtube = 'youtube',
}

export enum UIIconColorsEnum {
    AlertBlue = 'alert-blue',
    AlertGreen = 'alert-green',
    AlertRed = 'alert-red',
    AlertYellow = 'alert-yellow',
    Apricot = 'apricot',
    Bark = 'bark',
    Bark30 = 'bark-30',
    Bark40 = 'bark-40',
    Bark50 = 'bark-50',
    Bark60 = 'bark-60',
    Bark70 = 'bark-70',
    DarkVanilla = 'darkvanilla',
    Default = 'default',
    Grey = 'grey',
    InfoGray = 'info-gray',
    Lavender = 'lavender',
    LighterBark = 'lighterbark',
    Lilac = 'lilac',
    Listgrey = 'listgrey',
    MediumBrown = 'mediumbrown',
    Orange = 'orange',
    OrangeText = 'orange-text',
    Pineapple = 'pineapple',
    Rose = 'rose',
    Seafoam = 'seafoam',
    SoftBrown = 'softbrown',
    Tangerine = 'tangerine',
    Teal = 'teal',
    Tulip = 'tulip',
    Turquoise = 'turquoise',
    White = 'white',
    PfmIncome = 'pfm-income',
    PfmInvestments = 'pfm-investments',
    PfmHealth = 'pfm-health',
    PfmServices = 'pfm-services',
    PfmOther = 'pfm-other',
    PfmUnknown = 'pfm-unknown',
}

export enum UIFlagGlyphs {
    AD = 'ad',
    AE = 'ae',
    AF = 'af',
    AG = 'ag',
    AI = 'ai',
    AL = 'al',
    AM = 'am',
    AN = 'an',
    AO = 'ao',
    AR = 'ar',
    AS = 'as',
    AT = 'at',
    AU = 'au',
    AW = 'aw',
    AX = 'ax',
    AZ = 'az',
    BA = 'ba',
    BB = 'bb',
    BD = 'bd',
    BE = 'be',
    BF = 'bf',
    BG = 'bg',
    BH = 'bh',
    BI = 'bi',
    BJ = 'bj',
    BL = 'bl',
    BM = 'bm',
    BN = 'bn',
    BO = 'bo',
    BQ = 'bq',
    BR = 'br',
    BS = 'bs',
    BT = 'bt',
    BV = 'bv',
    BW = 'bw',
    BY = 'by',
    BZ = 'bz',
    CA = 'ca',
    CC = 'cc',
    CD = 'cd',
    CF = 'cf',
    CG = 'cg',
    CH = 'ch',
    CI = 'ci',
    CK = 'ck',
    CL = 'cl',
    CM = 'cm',
    CN = 'cn',
    CO = 'co',
    CR = 'cr',
    CS = 'cs',
    CU = 'cu',
    CV = 'cv',
    CW = 'cw',
    CX = 'cx',
    CY = 'cy',
    CZ = 'cz',
    DE = 'de',
    DJ = 'dj',
    DK = 'dk',
    DM = 'dm',
    DO = 'do',
    DZ = 'dz',
    EC = 'ec',
    EE = 'ee',
    EG = 'eg',
    EH = 'eh',
    ER = 'er',
    ES = 'es',
    ET = 'et',
    EU = 'eu',
    FI = 'fi',
    FJ = 'fj',
    FK = 'fk',
    FM = 'fm',
    FO = 'fo',
    FR = 'fr',
    GA = 'ga',
    GB = 'gb',
    GD = 'gd',
    GE = 'ge',
    GF = 'gf',
    GG = 'gg',
    GH = 'gh',
    GI = 'gi',
    GL = 'gl',
    GM = 'gm',
    GN = 'gn',
    GP = 'gp',
    GQ = 'gq',
    GR = 'gr',
    GS = 'gs',
    GT = 'gt',
    GU = 'gu',
    GW = 'gw',
    GY = 'gy',
    HK = 'hk',
    HM = 'hm',
    HN = 'hn',
    HR = 'hr',
    HT = 'ht',
    HU = 'hu',
    ID = 'id',
    IE = 'ie',
    IL = 'il',
    IM = 'im',
    IN = 'in',
    IO = 'io',
    IQ = 'iq',
    IR = 'ir',
    IS = 'is',
    IT = 'it',
    JE = 'je',
    JM = 'jm',
    JO = 'jo',
    JP = 'jp',
    KE = 'ke',
    KG = 'kg',
    KH = 'kh',
    KI = 'ki',
    KM = 'km',
    KN = 'kn',
    KP = 'kp',
    KR = 'kr',
    KW = 'kw',
    KY = 'ky',
    KZ = 'kz',
    LA = 'la',
    LB = 'lb',
    LC = 'lc',
    LI = 'li',
    LK = 'lk',
    LR = 'lr',
    LS = 'ls',
    LT = 'lt',
    LU = 'lu',
    LV = 'lv',
    LY = 'ly',
    MA = 'ma',
    MC = 'mc',
    MD = 'md',
    ME = 'me',
    MF = 'mf',
    MG = 'mg',
    MH = 'mh',
    MK = 'mk',
    ML = 'ml',
    MM = 'mm',
    MN = 'mn',
    MO = 'mo',
    MP = 'mp',
    MQ = 'mq',
    MR = 'mr',
    MS = 'ms',
    MT = 'mt',
    MU = 'mu',
    MV = 'mv',
    MW = 'mw',
    MX = 'mx',
    MY = 'my',
    MZ = 'mz',
    NA = 'na',
    NC = 'nc',
    NE = 'ne',
    NF = 'nf',
    NG = 'ng',
    NI = 'ni',
    NL = 'nl',
    NO = 'no',
    NP = 'np',
    NR = 'nr',
    NU = 'nu',
    NZ = 'nz',
    OM = 'om',
    PA = 'pa',
    PE = 'pe',
    PF = 'pf',
    PG = 'pg',
    PH = 'ph',
    PK = 'pk',
    PL = 'pl',
    PM = 'pm',
    PN = 'pn',
    PR = 'pr',
    PS = 'ps',
    PT = 'pt',
    PW = 'pw',
    PY = 'py',
    QA = 'qa',
    RE = 're',
    RO = 'ro',
    RS = 'rs',
    RU = 'ru',
    RW = 'rw',
    SA = 'sa',
    SB = 'sb',
    SC = 'sc',
    SD = 'sd',
    SE = 'se',
    SG = 'sg',
    SH = 'sh',
    SI = 'si',
    SJ = 'sj',
    SK = 'sk',
    SL = 'sl',
    SM = 'sm',
    SN = 'sn',
    SO = 'so',
    SR = 'sr',
    SS = 'ss',
    ST = 'st',
    SV = 'sv',
    SX = 'sx',
    SY = 'sy',
    SZ = 'sz',
    TC = 'tc',
    TD = 'td',
    TF = 'tf',
    TG = 'tg',
    TH = 'th',
    TJ = 'tj',
    TK = 'tk',
    TL = 'tl',
    TM = 'tm',
    TN = 'tn',
    TO = 'to',
    TR = 'tr',
    TT = 'tt',
    TV = 'tv',
    TW = 'tw',
    TZ = 'tz',
    UA = 'ua',
    UG = 'ug',
    UM = 'um',
    US = 'us',
    UY = 'uy',
    UZ = 'uz',
    VA = 'va',
    VC = 'vc',
    VE = 've',
    VG = 'vg',
    VI = 'vi',
    VN = 'vn',
    VU = 'vu',
    WF = 'wf',
    WS = 'ws',
    YE = 'ye',
    YT = 'yt',
    ZA = 'za',
    ZM = 'zm',
    ZW = 'zw',
}

export enum UIIconGlyphRedesigns {
    RedesignCaretDown = 'redesign-caret-down',
    RedesignCircleChart = 'redesign-circle-chart',
    RedesignTooltipQuestion = 'redesign-tooltip-question',
    RedesignFilledDot = 'redesign-filled-dot',
    RedesignShoppingCartPlus = 'redesign-shopping-cart-plus',
    RedesignFlashlight = 'redesign-flashlight',
    RedesignVideo1 = 'redesign-video-1',
    RedesignHouse = 'redesign-house',
    RedesignCircleSun = 'redesign-circle-sun',
    RedesignArrowDownToLines = 'redesign-arrow-down-to-lines',
    RedesignLineGrowthArrow = 'redesign-line-growth-arrow',
    RedesignCircleUmbrelled = 'redesign-circle-umbrella',
    RedesignWalletCreditCard = 'redesign-wallet-credit-card',
    RedesignChart = 'redesign-chart',
    RedesignCircleExclamation = 'redesign-circle-exclamation',
    RedesignNewWindow = 'redesign-new-window',
    RedesignLocationPinDot = 'redesign-location-pin-dot',
    RedesignGripLines = 'redesign-grip-lines',
    RedesignCircleXMarkThick = 'redesign-circle-xmark-thick',
    RedesignUmbrella = 'redesign-umbrella',
    RedesignFullscreen = 'redesign-fullscreen',
    RedesignArrowCurvedDown = 'redesign-arrow-curved-down',
    RedesignCircleHouse = 'redesign-circle-house',
    RedesignNavigateBack = 'redesign-navigate-back',
    RedesignCircle = 'redesign-circle',
    RedesignCircleArrowDownToLines = 'redesign-circle-arrow-down-to-lines',
    RedesignTooltipExclamationHover = 'redesign-tooltip-exclamation-hover',
    RedesignCircleOutlinedHalfDashedCheckmark = 'redesign-circle-outlined-half-dashed-checkmark',
    RedesignUserAdult = 'redesign-user-adult',
    RedesignChevronDown = 'redesign-chevron-down',
    RedesignFaceLaugh = 'redesign-face-laugh',
    RedesignCirclePercent = 'redesign-circle-percent',
    RedesignCircleEllipsisVertical = 'redesign-circle-ellipsis-vertical',
    RedesignFlashlightOutline = 'redesign-flashlight-outline',
    RedesignBlindPerson = 'redesign-blind-person',
    RedesignEllipsisVertical = 'redesign-ellipsis-vertical',
    RedesignDocumentDollar = 'redesign-document-dollar',
    RedesignCircleFaceSmile = 'redesign-circle-face-smile',
    RedesignCircleDollar = 'redesign-circle-dollar',
    RedesignArrowUpFromLines = 'redesign-arrow-up-from-lines',
    RedesignCheckCheck = 'redesign-check-check',
    RedesignCheckmarkThick = 'redesign-checkmark-thick',
    RedesignEmptyCircle3DotsHorizontal = 'redesign-empty-circle-3-dots-horizontal',
    RedesignDoubleChevronLeft = 'redesign-double-chevron-left',
    RedesignPaw = 'redesign-paw',
    RedesignCircleEllipsisHorizontalHover = 'redesign-circle-ellipsis-horizontal-hover',
    RedesignTooltipInfoHover = 'redesign-tooltip-info-hover',
    RedesignFlagWorld = 'redesign-flag-world',
    RedesignTooltipQuestionHover = 'redesign-tooltip-question-hover',
    RedesignCircleCheckmark = 'redesign-circle-checkmark',
    RedesignUserArrowsCircle = 'redesign-user-arrows-circle',
    RedesignChevronUp = 'redesign-chevron-up',
    RedesignLineStableArrow = 'redesign-line-stable-arrow',
    RedesignAddFolder = 'redesign-add-folder',
    RedesignFileArrowRight = 'redesign-file-arrow-right',
    RedesignFolderOpen = 'redesign-folder-open',
    RedesignQrCode = 'redesign-qr-code',
    RedesignUpRightAndDownLeftFromCenter = 'redesign-up-right-and-down-left-from-center',
    RedesignLock = 'redesign-lock',
    RedesignBan = 'redesign-ban',
    RedesignStarOutline = 'redesign-star-outline',
    RedesignPen = 'redesign-pen',
    RedesignChevronRight = 'redesign-chevron-right',
    RedesignLink = 'redesign-link',
    RedesignCircleWallet = 'redesign-circle-wallet',
    RedesignCircleBear = 'redesign-circle-bear',
    RedesignScreenSlash = 'redesign-screen-slash',
    RedesignEuroSignInsideCircleArrow = 'redesign-euro-sign-inside-circle-arrow',
    RedesignHouseLamp = 'redesign-house-lamp',
    RedesignThumbsDown = 'redesign-thumbs-down',
    RedesignUserGear = 'redesign-user-gear',
    RedesignCaretUp = 'redesign-caret-up',
    RedesignBookOpen = 'redesign-book-open',
    RedesignCircleCirclePercent = 'redesign-circle-circle-percent',
    RedesignCalculatorDocument = 'redesign-calculator-document',
    RedesignTimeHand = 'redesign-time-hand',
    RedesignCircleBookOpen = 'redesign-circle-book-open',
    RedesignWallet = 'redesign-wallet',
    RedesignBell = 'redesign-bell',
    RedesignEmptyCircleQuestionMark = 'redesign-empty-circle-question-mark',
    RedesignCode = 'redesign-code',
    RedesignLineGrowth = 'redesign-line-growth',
    RedesignCircleCar = 'redesign-circle-car',
    RedesignCircleEye = 'redesign-circle-eye',
    RedesignMagnifyingChart = 'redesign-magnifying-chart',
    Redesign4Squares = 'redesign-4-squares',
    RedesignCaretRight = 'redesign-caret-right',
    RedesignArrowsLeftRightMergedOnTop = 'redesign-arrows-left-right-merged-on-top',
    RedesignPlus = 'redesign-plus',
    RedesignDocument = 'redesign-document',
    RedesignCheck = 'redesign-check',
    RedesignCircleForkKnife = 'redesign-circle-fork-knife',
    RedesignTooltipExclamation = 'redesign-tooltip-exclamation',
    RedesignTooltipInfo = 'redesign-tooltip-info',
    RedesignInfo = 'redesign-info',
    RedesignHighRiseBuildingLamp = 'redesign-high-rise-building-lamp',
    RedesignRectanglesStackedPyramid = 'redesign-rectangles-stacked-pyramid',
    RedesignLoader = 'redesign-loader',
    RedesignGear = 'redesign-gear',
    RedesignXMark = 'redesign-x-mark',
    RedesignHandGear = 'redesign-hand-gear',
    RedesignMic = 'redesign-mic',
    RedesignCopy = 'redesign-copy',
    RedesignWritingPadPen = 'redesign-writing-pad-pen',
    RedesignCircleCoinsOntopOfLine = 'redesign-circle-coins-ontop-of-line',
    RedesignTreeHouse = 'redesign-tree-house',
    RedesignRefresh = 'redesign-refresh',
    RedesignImage = 'redesign-image',
    RedesignLamp = 'redesign-lamp',
    RedesignChartLineGrowthArrow = 'redesign-chart-line-growth-arrow',
    RedesignChatMessageSlash = 'redesign-chat-message-slash',
    RedesignEmptyCircleInfo = 'redesign-empty-circle-info',
    RedesignCoinsOntopOfLine = 'redesign-coins-ontop-of-line',
    RedesignEmptyCircleCheckmark = 'redesign-empty-circle-checkmark',
    RedesignThumbsUp = 'redesign-thumbs-up',
    RedesignCircleChatBubbles = 'redesign-circle-chat-bubbles',
    RedesignPercent = 'redesign-percent',
    RedesignFaceSmile = 'redesign-face-smile',
    RedesignArrowRightFromHalfOutlinedSquare = 'redesign-arrow-right-from-half-outlined-square',
    RedesignEyeSlash = 'redesign-eye-slash',
    RedesignPlay = 'redesign-play',
    RedesignPaperPlane = 'redesign-paper-plane',
    RedesignLineGrowthNodes = 'redesign-line-growth-nodes',
    RedesignCircleLock = 'redesign-circle-lock',
    RedesignBoxOutlinedChecked = 'redesign-box-outlined-checked',
    RedesignEmptyCirclePlus = 'redesign-empty-circle-plus',
    RedesignCirclePaw = 'redesign-circle-paw',
    RedesignEmptyCircleMinus = 'redesign-empty-circle-minus',
    RedesignChatBubbles = 'redesign-chat-bubbles',
    RedesignCircleFaceLaugh = 'redesign-circle-face-laugh',
    RedesignCircleUserAdult = 'redesign-circle-user-adult',
    RedesignCircleQuestionMark = 'redesign-circle-question-mark',
    RedesignCamera = 'redesign-camera',
    RedesignHighRiseBuilding = 'redesign-high-rise-building',
    RedesignArrowUpRight = 'redesign-arrow-up-right',
    RedesignChatMessage = 'redesign-chat-message',
    RedesignCircleUserChild = 'redesign-circle-user-child',
    RedesignArrowUpRightFromSquare = 'redesign-arrow-up-right-from-square',
    RedesignEnvelopeClosed = 'redesign-envelope-closed',
    RedesignCircleInfo = 'redesign-circle-info',
    RedesignThumbsNeutral = 'redesign-thumbs-neutral',
    RedesignCircleFolderOpen = 'redesign-circle-folder-open',
    RedesignCirclePlus = 'redesign-circle-plus',
    RedesignHashtag = 'redesign-hashtag',
    RedesignCircleXMark = 'redesign-circle-x-mark',
    RedesignStar = 'redesign-star',
    RedesignCircleEyeSlash = 'redesign-circle-eye-slash',
    RedesignEuroSign = 'redesign-euro-sign',
    RedesignSun = 'redesign-sun',
    RedesignTrashcan = 'redesign-trashcan',
    RedesignChatBubbleExclamation = 'redesign-chat-bubble-exclamation',
    RedesignBarsBlock = 'redesign-bars-block',
    RedesignWheelchair = 'redesign-wheelchair',
    RedesignCircleShoppingCart = 'redesign-circle-shopping-cart',
    RedesignArrowsLeftRight = 'redesign-arrows-left-right',
    RedesignCircleArrowsLeftRight = 'redesign-circle-arrows-left-right',
    RedesignArrowRightToHalfOutlinedSquare = 'redesign-arrow-right-to-half-outlined-square',
    RedesignTeddyBear = 'redesign-teddy-bear',
    RedesignMobileList = 'redesign-mobile-list',
    RedesignCreditCard = 'redesign-credit-card',
    RedesignLock1 = 'redesign-lock-1',
    RedesignSignPost = 'redesign-sign-post',
    RedesignCircleFlashlight = 'redesign-circle-flashlight',
    RedesignClock = 'redesign-clock',
    RedesignPhone = 'redesign-phone',
    RedesignQuestionMark = 'redesign-question-mark',
    RedesignEye = 'redesign-eye',
    RedesignMobile = 'redesign-mobile',
    RedesignForkKnife = 'redesign-fork-knife',
    RedesignEmptyCircleXmark = 'redesign-empty-circle-xmark',
    RedesignCar = 'redesign-car',
    RedesignEllipsisHorizontal = 'redesign-ellipsis-horizontal',
    RedesignMobilePlus = 'redesign-mobile-plus',
    RedesignAtmInOut = 'redesign-atm-in-out',
    RedesignCircleClock = 'redesign-circle-clock',
    RedesignDownLeftAndUpRightToCenter = 'redesign-down-left-and-up-right-to-center',
    RedesignEmptyCircle3DotsVertical = 'redesign-empty-circle-3-dots-vertical',
    RedesignVideo = 'redesign-video',
    RedesignCaretUpDown = 'redesign-caret-up-down',
    RedesignTriangleExclamation = 'redesign-triangle-exclamation',
    RedesignDoubleChevronRight = 'redesign-double-chevron-right',
    RedesignVideoSlash = 'redesign-video-slash',
    RedesignBarsFilter = 'redesign-bars-filter',
    RedesignSquareMinus = 'redesign-square-minus',
    RedesignMagnifyingGlass = 'redesign-magnifying-glass',
    RedesignArrowDownRight = 'redesign-arrow-down-right',
    RedesignEmpyDot = 'redesign-empy-dot',
    RedesignCaretLeft = 'redesign-caret-left',
    RedesignCircleEllipsisHorizontal = 'redesign-circle-ellipsis-horizontal',
    RedesignCarHouse = 'redesign-car-house',
    RedesignAtmIn = 'redesign-atm-in',
    RedesignBars = 'redesign-bars',
    RedesignEmptyCircleExclamation = 'redesign-empty-circle-exclamation',
    RedesignMicSlash = 'redesign-mic-slash',
    RedesignPause = 'redesign-pause',
    RedesignArrowDownArrowUp = 'redesign-arrow-down-arrow-up',
    RedesignCircleMinus = 'redesign-circle-minus',
    RedesignRotateRight = 'redesign-rotate-right',
    RedesignScreen = 'redesign-screen',
    RedesignBoxEmpty = 'redesign-box-empty',
    RedesignCirclePrint = 'redesign-circle-print',
    RedesignCirclePen = 'redesign-circle-pen',
    RedesignPaperclip45Degrees = 'redesign-paperclip-45degrees',
    RedesignCircleHeart = 'redesign-circle-heart',
    RedesignShoppingCart = 'redesign-shopping-cart',
    RedesignCalculator = 'redesign-calculator',
    RedesignPensionTriangle = 'redesign-pension-triangle',
    RedesignBookDictionary = 'redesign-book-dictionary',
    RedesignHearingAid = 'redesign-hearing-aid',
    RedesignUsers = 'redesign-users',
    RedesignFilePdf = 'redesign-file-pdf',
    RedesignMinus = 'redesign-minus',
    RedesignChevronLeft = 'redesign-chevron-left',
    RedesignPrint = 'redesign-print',
    RedesignSystemNavigateBackIos = 'redesign-system-navigate-back-ios',
    RedesignExclamation = 'redesign-exclamation',
    RedesignEInvoice = 'redesign-e-invoice',
    RedesignCloudCo2 = 'redesign-cloud-co2',
    RedesignXMarkThick = 'redesign-xmark-thick',
    RedesignCalendarDays = 'redesign-calendar-days',
    RedesignHeart = 'redesign-heart',
    RedesignXTwitter = 'redesign-x-twitter',
    RedesignInstagram = 'redesign-instagram',
    RedesignSmartId = 'redesign-smart-id',
    RedesignFacebook = 'redesign-facebook',
    RedesignMorningstarSustainabilityRatingLogoActive = 'redesign-morningstar-sustainability-rating-logo-active',
    RedesignYoutube = 'redesign-youtube',
    RedesignMorningstarSustainabilityRatingLogoBlue = 'redesign-morningstar-sustainability-rating-logo-blue',
    RedesignLinkedin = 'redesign-linkedin',
    RedesignMorningstarSustainabilityRatingLogoInactive = 'redesign-morningstar-sustainability-rating-logo-inactive',
    RedesignSkype = 'redesign-skype',
    RedesignFlagTr = 'redesign-flag-tr',
    RedesignFlagCl = 'redesign-flag-cl',
    RedesignFlagLt = 'redesign-flag-lt',
    RedesignFlagCz = 'redesign-flag-cz',
    RedesignFlagAe = 'redesign-flag-ae',
    RedesignFlagLv = 'redesign-flag-lv',
    RedesignFlagCn = 'redesign-flag-cn',
    RedesignFlagAu = 'redesign-flag-au',
    RedesignFlagNz = 'redesign-flag-nz',
    RedesignFlagNl = 'redesign-flag-nl',
    RedesignFlagUs = 'redesign-flag-us',
    RedesignFlagTw = 'redesign-flag-tw',
    RedesignFlagNo = 'redesign-flag-no',
    RedesignFlagCh = 'redesign-flag-ch',
    RedesignFlagDk = 'redesign-flag-dk',
    RedesignFlagIl = 'redesign-flag-il',
    RedesignFlagKr = 'redesign-flag-kr',
    RedesignFlagHk = 'redesign-flag-hk',
    RedesignFlagIn = 'redesign-flag-in',
    RedesignFlagGr = 'redesign-flag-gr',
    RedesignFlagPl = 'redesign-flag-pl',
    RedesignFlagPh = 'redesign-flag-ph',
    RedesignFlagFr = 'redesign-flag-fr',
    RedesignFlagJp = 'redesign-flag-jp',
    RedesignFlagSe = 'redesign-flag-se',
    RedesignFlagSg = 'redesign-flag-sg',
    RedesignFlagGb = 'redesign-flag-gb',
    RedesignFlagRu = 'redesign-flag-ru',
    RedesignFlagRo = 'redesign-flag-ro',
    RedesignFlagIe = 'redesign-flag-ie',
    RedesignFlagId = 'redesign-flag-id',
    RedesignFlagIs = 'redesign-flag-is',
    RedesignFlagFi = 'redesign-flag-fi',
    RedesignFlagEe = 'redesign-flag-ee',
    RedesignFlagHu = 'redesign-flag-hu',
    RedesignFlagEs = 'redesign-flag-es',
    RedesignFlagIt = 'redesign-flag-it',
    RedesignFlagDe = 'redesign-flag-de',
    RedesignFlagEu = 'redesign-flag-eu',
    RedesignFlagPt = 'redesign-flag-pt',
    RedesignFlagMy = 'redesign-flag-my',
    RedesignFlagMx = 'redesign-flag-mx',
    RedesignFlagZa = 'redesign-flag-za',
    RedesignFlagBg = 'redesign-flag-bg',
    RedesignFlagBr = 'redesign-flag-br',
    RedesignFlagBe = 'redesign-flag-be',
    RedesignFlagCa = 'redesign-flag-ca',
    RedesignFlagTh = 'redesign-flag-th',
    RedesignStatusPending = 'redesign-status-pending',
    RedesignStatusInactive = 'redesign-status-inactive',
    RedesignStatusProcessing = 'redesign-status-processing',
    RedesignStatusActive = 'redesign-status-active',
    RedesignAlertInfo = 'redesign-alert-info',
    RedesignAlertWarning = 'redesign-alert-warning',
    RedesignAlertError = 'redesign-alert-error',
    RedesignAlertSuccess = 'redesign-alert-success',
}

export const UIIconColors: Record<string, UIIconColor> = {
    DEFAULT: 'default',
    ORANGE: 'orange',
    ORANGE_TEXT: 'orange-text',
    PINEAPPLE: 'pineapple',
    TURQUOISE: 'turquoise',
    TEAL: 'teal',
    SEAFOAM: 'seafoam',
    LILAC: 'lilac',
    TULIP: 'tulip',
    LAVENDER: 'lavender',
    LISTGREY: 'listgrey',
    GREY: 'grey',
    WHITE: 'white',
    ALERT_RED: 'alert-red',
    ALERT_GREEN: 'alert-green',
    ALERT_BLUE: 'alert-blue',
    ALERT_YELLOW: 'alert-yellow',
    TANGERINE: 'tangerine',
    APRICOT: 'apricot',
    ROSE: 'rose',
    BARK_70: 'bark-70',
    BARK_60: 'bark-60',
    BARK_50: 'bark-50',
    BARK_40: 'bark-40',
    BARK_30: 'bark-30',
    BARK: 'bark' /* should deprecate */,
    MEDIUMBROWN: 'mediumbrown' /* should deprecate */,
    DARKVANILLA: 'darkvanilla' /* should deprecate */,
    SOFTBROWN: 'softbrown' /* should deprecate */,
    LIGHTERBARK: 'lighterbark' /* should deprecate */,
    INFO_GRAY: 'info-gray',
};

export const DeprecatedColors: Array<string | UIIconColor> = [
    'brown',
    'orange-wcag',
    'yellow',
    'info-yellow',
    'blue',
    'turquoise-wcag',
    'info-turquoise',
    'lilac-wcag',
    'info-lilac',
    'info-pink',
    'info-blue',
    'info-mediumbrown',
    'lightgray',
    'info-brown',
    'info-gray',
    'gray',
    'red',
    'info-green',
    'alert-success',
    'bark',
    'darkvanilla',
    'mediumbrown',
    'softbrown',
    'lighterbark',
];

const AvatarBackgroundColors = {
    White: UIIconColors.WHITE,
    Rose: UIIconColors.ROSE,
    Orange: UIIconColors.ORANGE,
    Turquoise: UIIconColors.TURQUOISE,
    Lilac: UIIconColors.LILAC,
};

const avatarForegroundColorMap = {
    [AvatarBackgroundColors.White]: [
        UIIconColors.ORANGE,
        UIIconColors.TURQUOISE,
        UIIconColors.LILAC,
    ],
    [AvatarBackgroundColors.Rose]: [UIIconColors.ORANGE],
    [AvatarBackgroundColors.Orange]: [UIIconColors.WHITE],
    [AvatarBackgroundColors.Turquoise]: [UIIconColors.WHITE],
    [AvatarBackgroundColors.Lilac]: [UIIconColors.WHITE],
};
const getWarningMessage = (backgroundColor?: UIIconColor) => {
    const possibleAvatarBackgroundColors = Object.values(
        AvatarBackgroundColors
    );

    if (
        backgroundColor &&
        possibleAvatarBackgroundColors.includes(backgroundColor)
    ) {
        return `Allowed foreground color${backgroundColor === UIIconColors.WHITE ? 's are' : ' is'}: ${avatarForegroundColorMap[backgroundColor].join(', ')}.`;
    }

    return `Allowed background colors are: ${possibleAvatarBackgroundColors.join(', ')}.`;
};

/**
 * Enforces icon, text and checkmark avatar color palette.
 * @param {UIIconColor} backgroundColor
 * @param {UIIconColor} foregroundColor
 * @returns {{backgroundColor: UIIconColor | undefined, foregroundColor: UIIconColor | undefined, warningMessage: string | undefined}}
 */
export const getColorPalette = (
    backgroundColor: UIIconColor,
    foregroundColor: UIIconColor
): UIIconColorPalette => {
    const colorPalette: UIIconColorPalette = {
        backgroundColor,
        foregroundColor,
    };

    if (backgroundColor.startsWith('pfm-')) {
        return {
            ...colorPalette,
            foregroundColor: UIIconColors.WHITE,
        };
    }

    switch (backgroundColor) {
        case AvatarBackgroundColors.White:
            if (
                ![
                    UIIconColors.ORANGE,
                    UIIconColors.TURQUOISE,
                    UIIconColors.LILAC,
                ].includes(foregroundColor)
            ) {
                colorPalette.foregroundColor = UIIconColors.ORANGE;
                colorPalette.warningMessage =
                    getWarningMessage(backgroundColor);
            }
            break;
        case AvatarBackgroundColors.Rose:
            if (colorPalette.foregroundColor !== UIIconColors.ORANGE) {
                colorPalette.foregroundColor = UIIconColors.ORANGE;
                colorPalette.warningMessage =
                    getWarningMessage(backgroundColor);
            }
            break;
        case AvatarBackgroundColors.Orange:
        case AvatarBackgroundColors.Turquoise:
        case AvatarBackgroundColors.Lilac:
            if (colorPalette.foregroundColor !== UIIconColors.WHITE) {
                colorPalette.foregroundColor = UIIconColors.WHITE;
                colorPalette.warningMessage =
                    getWarningMessage(backgroundColor);
            }
            break;
        default:
            colorPalette.foregroundColor = UIIconColors.WHITE;
            colorPalette.backgroundColor = UIIconColors.LILAC;
            colorPalette.warningMessage = getWarningMessage();
            break;
    }

    return colorPalette;
};

export const colorValidator: AttributeValidationHandler = (
    component,
    value
) => {
    const info =
        `Allowed options are: default, bark-70, orange, orange-text, lilac, ` +
        `pineapple, turquoise, teal, seafoam, tulip, tangerine, lavender, rose, ` +
        `listgrey, grey, white, alert-red, alert-green, alert-blue, alert-yellow, apricot, ` +
        `bark-60, bark-50, bark-30.`;
    if (DeprecatedColors.includes(value)) {
        console.warn(`${value} - color is deprecated. ${info}`, component);
        return;
    }
    if (
        !Object.keys(UIIconColors).includes(
            value.toUpperCase().replace('-', '_')
        )
    ) {
        console.warn(`${value} - value does not exist. ${info}`, component);
    }
};

export enum UIIconLayouts {
    CUSTOM = 'custom',
    DEFAULT = 'default',
}
